export default {
  install: (app, options) => {
    const limitString = (value, length) => {
      if (
        value !== null &&
        value !== undefined &&
        length !== null &&
        value.length > length
      ) {
        return value.substring(0, length) + "...";
      }

      return value;
    };

    const decodeHtmlSpecialChars = (value) => {
      if (value !== null && value !== undefined && length !== null) {
        return value.replace(/&#(\d+);/g, (match, dec) =>
          String.fromCharCode(dec)
        );
      }

      return value;
    };

    const downloadICSFile = (data, name) => {
      const fileURL = window.URL.createObjectURL(
        new Blob([data], { type: "text/calendar" })
      );
      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", name.replaceAll(/\s+/g, "_") + ".ics");
      fileLink.setAttribute("data-no-external-modal", "true");

      document.body.appendChild(fileLink);
      fileLink.click();

      // Remove the link after a short delay to ensure event propagation
      setTimeout(() => {
        document.body.removeChild(fileLink);
        window.URL.revokeObjectURL(fileURL);
      }, 100);
    };

    const copyToClipboard = (text) => {
      navigator.clipboard.writeText(text);
    };

    app.config.globalProperties.$helperFunctions = {
      limitString,
      decodeHtmlSpecialChars,
      downloadICSFile,
      copyToClipboard,
    };
  },
};
